import Auth from "@/lib/common/auth";
import { getDimensionColor } from "@/lib/dimension/dimension-color";
import Model from "@/lib/model/model";
import request from "@/lib/request/request";
import { ScoreRole } from "./score-role";

export class QuestionDimension extends Model {
  dimensionKey = ""; // 维度键
  dimensionName = ""; // 维度名
  scoreRule: ScoreRole | null = new ScoreRole(); // 评分规则 仅视频题 且非 沟通表达+形象素质
  selectedQuestionCount = 0;
  totalScore = 0;
  isCurrentExamUsed = 0;

  //不需要提交
  err = false;
  showError() {
    if (this.selectedQuestionCount > 0) this.err = false;
    return this.err;
  }

  backgroundColor = "";
  color = "";
  assign(data: any): any {
    const instance = super.assign(data);
    const colorConfig = getDimensionColor(this.dimensionKey);
    instance.backgroundColor = colorConfig["background-color"];
    instance.color = colorConfig["color"];
    return instance;
  }

  get isCustom() {
    return this.dimensionKey === "自定义客观题";
  }
}

export class DimensionScoreConfig extends Model {
  dimensionKey = ""; // 维度键
  questionId = "";
  videoQuestionScore = 0;
  dimensionScore = 0;
}

export class DimensionObject extends Model {
  list: QuestionDimension[] = [new QuestionDimension()];
  count = 0;
  //获取题库试题List
  static get(params = {}, url = "aiExam/dimension/list") {
    params["companyId"] = Auth.companyId;

    return request.post(url, params).then(resp => {
      const qo = new DimensionObject(resp).assign(resp.data.data);
      console.log(qo);
      return qo;
    });
  }
}
